import React, { useState } from 'react';
import FormInput from '../elements/form_input';
import Button from '../elements/button';

const FarmRegistration = ({ onClose }) => {
    const [formData, setFormData] = useState({
        farmName: '',
        location: '',
        farmType: 'pond',
        species: [],
        capacity: '',
        waterSource: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle farm registration
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Register Your Farm</h2>
                <form onSubmit={handleSubmit}>
                    <FormInput
                        label="Farm Name"
                        value={formData.farmName}
                        onChange={(e) => setFormData({...formData, farmName: e.target.value})}
                    />
                    <FormInput
                        label="Location"
                        value={formData.location}
                        onChange={(e) => setFormData({...formData, location: e.target.value})}
                    />
                    <select 
                        value={formData.farmType}
                        onChange={(e) => setFormData({...formData, farmType: e.target.value})}
                    >
                        <option value="pond">Pond Culture</option>
                        <option value="tank">Tank System</option>
                        <option value="cage">Cage Culture</option>
                    </select>
                    <Button text="Register Farm" type="submit" />
                </form>
            </div>
        </div>
    );
};

export default FarmRegistration;